import React from "react";
import { SvgIcon } from "@mui/material";
import styles from "../MailPopup.module.css";

/**
 * Presentational list of the mail's attachments with a per-item remove
 * action. Renders nothing when there are no attachments. Pure move of the
 * attachments markup that previously lived inline in MailPopup.
 */
function AttachmentsRow({ attachments, onRemove }) {
  if (!attachments || attachments.length === 0) return null;

  return (
    <div className={styles.attachments_row}>
      <div className={styles.attachment_prefix}>Attachments: </div>
      {attachments.map((x, index) => {
        return (
          <div key={index} className={styles.attachment_item}>
            {x.filename}
            {
              <SvgIcon
                className={styles.attachment_delete_icon}
                onClick={(e) => onRemove(x)}
                children={
                  <>
                    <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                  </>
                }
              ></SvgIcon>
            }
          </div>
        );
      })}
    </div>
  );
}

export default AttachmentsRow;
